export const defaultClientLogo = 'https://truelayer-client-logos.s3.amazonaws.com/placeholder.svg'
